export const CM_IN_PERSON = "in_person";
export const CM_VIRTUAL = "virtual";
export const CM_BOTH = "both";

/** Lista de modalidades permitidas para agendar según `consultationModes` del psicólogo. */
export function allowedModalitiesFromPsych(consultationModes) {
  const cm = consultationModes || CM_BOTH;
  if (cm === CM_BOTH) return [CM_IN_PERSON, CM_VIRTUAL];
  if (cm === CM_IN_PERSON) return [CM_IN_PERSON];
  if (cm === CM_VIRTUAL) return [CM_VIRTUAL];
  return [CM_IN_PERSON, CM_VIRTUAL];
}

/** True si el psicólogo puede atender en esta modalidad de cita (presencial / virtual). */
export function psychSupportsAppointmentModality(consultationModes, appointmentModality) {
  if (!appointmentModality) return false;
  return allowedModalitiesFromPsych(consultationModes).includes(appointmentModality);
}

export function labelConsultationModesSetting(cm) {
  switch (cm) {
    case CM_IN_PERSON:
      return "Solo sesiones presenciales";
    case CM_VIRTUAL:
      return "Solo sesiones virtuales";
    case CM_BOTH:
      return "Presencial y virtual";
    default:
      return "Presencial y virtual";
  }
}

export function labelAppointmentModality(m) {
  if (m === CM_VIRTUAL) return "Virtual";
  if (m === CM_IN_PERSON) return "Presencial";
  return m ? String(m) : "—";
}
